// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MJSlSi0gAtcljhd8TNiP{display:flex;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/pages/App/FinishSetup/HPSmartAdminValuePropPage.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,sBAAA","sourcesContent":[".contentContainer {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `MJSlSi0gAtcljhd8TNiP`
};
export default ___CSS_LOADER_EXPORT___;
